module.exports = __webpack_public_path__ + "img/partner-top.03798e62.png";